module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'form/share' && templateVars.config ?
				templateVars.config :
				{
	"submitHandlerUrl": "${rootUrl}/contact/share",
	"cleanOnClose": true,
	"smartPlaceholder": true
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/form/.variant/share/config.yaml
// module id = 130
// module chunks = 0